var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 319,
    height: 205.86,
    viewBox: "0 0 319 205.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pop_up_icons",
    "data-name": "Pop up icons",
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_11",
    "data-name": "\\u692D\\u5706 11",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(233 96.256)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-warning",
    "data-name": "Icon ionic-ios-warning",
    d: "M99.884,12.982,5.4,185.406C-.573,196.183,7.376,209.36,19.86,209.36H208.875c12.43,0,20.379-13.177,14.458-23.954L128.8,12.982A16.562,16.562,0,0,0,99.884,12.982Zm23.847,71.541-1.921,65.086H106.872l-1.921-65.086Zm-9.389,100.509a9.823,9.823,0,1,1,10.19-9.816A9.911,9.911,0,0,1,114.341,185.033Z",
    transform: "translate(61.626 -4.5)",
    fill: "#f8d0cf"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_12",
    "data-name": "\\u692D\\u5706 12",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(0 140.256)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_14",
    "data-name": "\\u692D\\u5706 14",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(65.001 25.256)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_13",
    "data-name": "\\u692D\\u5706 13",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(299 45.43)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_15",
    "data-name": "\\u692D\\u5706 15",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(223 15.43)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-warning-2",
    "data-name": "Icon ionic-ios-warning",
    d: "M99.884,12.982,5.4,185.406C-.573,196.183,7.376,209.36,19.86,209.36H208.875c12.43,0,20.379-13.177,14.458-23.954L128.8,12.982A16.562,16.562,0,0,0,99.884,12.982Zm23.847,71.541-1.921,65.086H106.872l-1.921-65.086Zm-9.389,100.509a9.823,9.823,0,1,1,10.19-9.816A9.911,9.911,0,0,1,114.341,185.033Z",
    transform: "translate(50.668 -4.5)",
    fill: "none",
    stroke: "#ff6767",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningModal);
export default __webpack_public_path__ + "static/media/warningModal.84d5aa329965607e7a7b2eef7d08b929.svg";
export { ForwardRef as ReactComponent };